import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { PhoneShowcase } from "@/components/sections/PhoneShowcase";
import { SHOP } from "@/constants/testIds";

export default function Shop() {
  return (
    <div data-testid={SHOP.page}>
      <section className="relative overflow-hidden border-b border-border">
        <div className="absolute inset-0 hero-glow" />
        <div className="absolute inset-0 grid-pattern opacity-60" />
        <div className="container-x relative py-12 sm:py-16">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
            <ArrowLeft className="h-4 w-4" /> Torna alla home
          </Link>
          <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-border bg-card px-3 py-1.5 text-xs font-medium text-muted-foreground glow">
            <ShieldCheck className="h-3.5 w-3.5 text-accent" /> Servizio e 1 anno di pannello inclusi
          </div>
          <h1 className="mt-4 text-3xl sm:text-5xl font-semibold tracking-tight">Shop — Telefoni già preinstallati</h1>
          <p className="mt-4 max-w-2xl text-muted-foreground text-base leading-relaxed">
            Tutti i nostri smartphone arrivano con il servizio di controllo parentale già installato e configurato, con 1 anno
            di abbonamento al pannello cloud incluso. Scegli il modello e completa l'acquisto in pochi clic.
          </p>
        </div>
      </section>
      <PhoneShowcase hideHeading />
    </div>
  );
}
